__turbopack_context__.v({
  "className": "ppneuemontreal_14c41015-module__KS-omq__className",
  "variable": "ppneuemontreal_14c41015-module__KS-omq__variable",
});
